import { render, staticRenderFns } from "./KidsHeightWeightDetail.vue?vue&type=template&id=4f3c3104&scoped=true"
import script from "./KidsHeightWeightDetail.vue?vue&type=script&lang=js"
export * from "./KidsHeightWeightDetail.vue?vue&type=script&lang=js"
import style0 from "./KidsHeightWeightDetail.vue?vue&type=style&index=0&id=4f3c3104&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3c3104",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f3c3104')) {
      api.createRecord('4f3c3104', component.options)
    } else {
      api.reload('4f3c3104', component.options)
    }
    module.hot.accept("./KidsHeightWeightDetail.vue?vue&type=template&id=4f3c3104&scoped=true", function () {
      api.rerender('4f3c3104', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/studentquality/KidsHeightWeightDetail.vue"
export default component.exports